// extracted by mini-css-extract-plugin
export default {"mobileView":"MobileViwe_mobileView__ODDnr","head1":"MobileViwe_head1__cjyup","head2":"MobileViwe_head2__2uqhQ"};